import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from 'material-ui/FlatButton';
import { List } from 'material-ui/List';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import LeaseItems from './leaseItems/LeaseItems';

import { getTenancyInfo } from 'actions/tenantProfileActions';

import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyDateString, formatMoney } from 'helpers/Formatter';

import { localize } from 'react-localize-redux';

const style = {
  subheader: {
    lineHeight: 0,
    padding: '20px 16px 10px 16px',
  },
  lease_term: {
    margin: 0,
    fontSize: '15px',
  },
  subheader_side_padding: {
    padding: '0 16px',
  },
  no_padding: {
    padding: 0,
  },
};

let TenancyInfo = class extends React.Component {
  componentDidMount = () => {
    this.props.getTenancyInfo();
  };

  render() {
    return (
      <Dialog
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        aria-labelledby="view-documents"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="view-documents">
          <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
            {this.props.translate('tenancy.yourTenancy')}
            <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
          </h3>
        </DialogTitle>
        <DialogContent>{this.renderDialogContent()}</DialogContent>
        <DialogActions style={{ display: 'block' }}>{this.renderDialogActions()}</DialogActions>
      </Dialog>
    );
  }

  renderDialogContent = () => {
    const tenancyInfoData = this.props.tenancyInfo;

    return (
      <List style={style.no_padding}>
        <div style={{ borderTop: `5px solid ${AccentColor()}`, marginTop: '5px' }}>
          {this.renderExternalLeaseId()}
          <div className="col-xs-6" style={style.no_padding}>
            <h5 style={{ padding: '20px 16px 0' }}>
              {this.props.translate('tenancy.leaseExpiry')}
            </h5>
            <div style={style.subheader_side_padding}>
              <p style={style.lease_term}>
                {this.renderLeaseExpiryVerbiage()}
                {this.renderMonthToMonthVerbiage()}
              </p>
            </div>
          </div>

          <div className="col-xs-6" style={style.no_padding}>
            <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('property')}</h5>
            <div style={style.subheader_side_padding}>
              <p style={style.lease_term}>{tenancyInfoData.property_name}</p>
            </div>
          </div>

          <div className="col-xs-6" style={style.no_padding}>
            <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('unit')}</h5>
            <div style={style.subheader_side_padding}>
              <p style={style.lease_term}>{tenancyInfoData.unit_number}</p>
            </div>
          </div>

          <div className="col-xs-6" style={style.no_padding}>
            <h5 style={{ padding: '20px 16px 0' }}>
              {this.props.translate('payment_type.monthly_rent')}
            </h5>
            <div style={style.subheader_side_padding}>
              <p style={style.lease_term}>
                {formatMoney(tenancyInfoData.total_monthly_rent_in_float)}
              </p>
            </div>
          </div>

          <div className="col-xs-12" style={style.no_padding}>
            <LeaseItems leaseCharges={tenancyInfoData.lease_charges} />
          </div>

          {this.renderDates()}
        </div>
      </List>
    );
  };

  renderExternalLeaseId = () => {
    if (!this.props.tenancyInfo.external_lease_id) return null;

    return (
      <div className="col-xs-6" style={style.no_padding}>
        <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('tenancy.leaseId')}</h5>
        <div style={style.subheader_side_padding}>
          <p style={style.lease_term}>{this.props.tenancyInfo.external_lease_id}</p>
        </div>
      </div>
    );
  };

  renderDates = () => {
    return (
      <Fragment>
        <div className="col-xs-6" style={style.no_padding}>
          <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('moveInDate')}</h5>
          <div style={style.subheader_side_padding}>
            <p style={style.lease_term}>
              {toFriendlyDateString(this.props.tenancyInfo.move_in_date)}
            </p>
          </div>
        </div>
        {this.props.tenancyInfo.move_out_date && (
          <div className="col-xs-6" style={style.no_padding}>
            <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('moveOutDate')}</h5>
            <div style={style.subheader_side_padding}>
              <p style={style.lease_term}>
                {toFriendlyDateString(this.props.tenancyInfo.move_out_date)}
              </p>
            </div>
          </div>
        )}
      </Fragment>
    );
  };

  renderMonthToMonthVerbiage = () => {
    if (!this.props.tenancyInfo.month_to_month) return;

    return this.props.translate('tenancy.monthToMonth');
  };

  renderLeaseExpiryVerbiage = () => {
    if (this.props.tenancyInfo.month_to_month) return;

    return toFriendlyDateString(this.props.tenancyInfo.lease_end, {
      language: this.props.currentLanguage,
    });
  };

  renderDialogActions = () => (
    <Fragment>
      <FlatButton
        onClick={this.props.toggleDialog}
        id="close-button"
        style={{ color: AccentColor(), textTransform: 'uppercase' }}
      >
        {this.props.translate('close')}
      </FlatButton>
    </Fragment>
  );
};

TenancyInfo = withMobileDialog()(
  connect(
    state => ({
      tenancyInfo: state.tenantProfile.tenancyInfo,
      currentLanguage: state.locale.currentLanguage,
    }),
    { getTenancyInfo }
  )(TenancyInfo)
);

export default localize()(TenancyInfo);
